import React from 'react';
import Card from '../../../components/ACS-Dashboard/ACS-Blocks/Card';
import ScrollableContainer from '../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer';

const InvoiceList = ({ isCollapsed }) => {
  // Sample data for the scrollable cards
  const cardsData = [
    {
      title: "Approved Invoices",
      percentage: "+8%",
      comparisonText: "vs last week",
      mainValue: "42",
      buttonText: "View"
    },
    {
      title: "Pending Invoices",
      percentage: "-3%",
      comparisonText: "vs yesterday",
      mainValue: "19",
      buttonText: "Review"
    },
    {
      title: "Draft Invoices",
      percentage: "+12%",
      comparisonText: "vs last month",
      mainValue: "31",
      buttonText: "Edit"
    },
    {
      title: "Rejected Invoices",
      percentage: "+2%",
      comparisonText: "vs last month",
      mainValue: "6",
      buttonText: "Check"
    },
    {
      title: "Invoiced Amount",
      percentage: "+5%",
      comparisonText: "vs last week",
      mainValue: "$24,000",
      buttonText: "Details"
    },
    {
      title: "Invoices Ready for Audit",
      percentage: "+9%",
      comparisonText: "vs last audit cycle",
      mainValue: "14",
      buttonText: "Audit"
    },
    {
      title: "Exceptions Flagged",
      percentage: "+4%",
      comparisonText: "vs last month",
      mainValue: "9",
      buttonText: "Resolve"
    }
  ];
  

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]">
          {cardsData.map((card, index) => (
            <div 
              key={index} 
              className="scroll-snap-align-start"
              style={{ 
                minWidth: 'clamp(12rem,30cqw,11rem)',
                flex: '0 0 auto'
              }}
            >
              <Card 
                {...card}
                className="p-fluid-1.5"
                titleClassName="text-fluid-lg"
                valueClassName="text-fluid-xl"
                metaClassName="text-fluid-sm"
              />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default InvoiceList;
